module.exports = __webpack_public_path__ + "img/qq.2366d103.svg";